import { ImportUsersStatus, RECORD_STATUSES } from '../../api/types';
import { CSVUsersInfo, Record } from './types';

export const getCSVUsersInfo = (data: ImportUsersStatus): CSVUsersInfo | null => {
    if (data) {
        const errorRecords = data.errors;

        const recordsInfo = Object.keys(errorRecords).reduce(
            (acc: { records: Record[]; conflictCount: number; invalidCount: number }, key: string) => {
                const item = errorRecords[key];

                if (item.isSuccess) return acc;

                const record: Record = {
                    label: key,
                    isSuccess: item.isSuccess,
                    status: item.status,
                    errors: item.errors,
                };

                return {
                    records: [...acc.records, record],
                    conflictCount: acc.conflictCount + (item.status === RECORD_STATUSES.CONFLICT ? 1 : 0),
                    invalidCount: acc.invalidCount + (item.status === RECORD_STATUSES.INVALID ? 1 : 0),
                };
            },
            {
                records: [],
                conflictCount: 0,
                invalidCount: 0,
            }
        );

        return {
            ...recordsInfo,
            succeedCount: data?.succeedCount,
        };
    }

    return null;
};
